/** Dicionários Dragon Tech (shell + páginas). */

import { PAGE_MESSAGES } from './pageMessages';
import { MODAL_MESSAGES } from './modalMessages';
import { ROLE_UI_MESSAGES } from './roleUiMessages';
import { OPS_UI_MESSAGES } from './opsUiMessages';

export { intlLocaleFor } from './pageMessages';

export const LOCALES = [
  {
    code: 'pt-BR',
    label: 'Português (BR)',
    short: 'PT',
    flagCode: 'br',
    htmlLang: 'pt-BR',
  },
  {
    code: 'en',
    label: 'English',
    short: 'EN',
    flagCode: 'us',
    htmlLang: 'en',
  },
  {
    code: 'es',
    label: 'Español',
    short: 'ES',
    flagCode: 'es',
    htmlLang: 'es',
  },
];

export const DEFAULT_LOCALE = 'pt-BR';

const ptBR = {
  'lang.title': 'Idioma',
  'lang.choose': 'Escolher idioma',
  'header.tools': 'Ferramentas',
  'header.themeColor': 'Cor do tema',
  'header.toggleTheme': 'Alternar tema',
  'header.notifications': 'Notificações',
  'header.fullscreen': 'Tela cheia',
  'header.openMenu': 'Abrir menu',
  'header.mobilePrefs': 'Preferências',
  'header.mobilePrefsHint': 'Personalize tema, cor e idioma — sincroniza em todos os dispositivos.',
  'header.quickAccess': 'Acesso rápido',
  'header.personalization': 'Personalização',
  'header.mobileToolsHint': 'Atalhos operacionais do escritório',
  'header.mobileMore': 'Preferências e atalhos',
  'header.shortcuts': 'Atalhos',
  'header.navigation': 'Navegação',
  'header.workspace': 'Visualização e aplicativo',
  'header.lightMode': 'Modo claro',
  'header.darkMode': 'Modo escuro',
  'header.exitFullscreen': 'Sair da tela cheia',
  'header.fullscreenUnavailable': 'Seu navegador não permitiu abrir a tela cheia.',
  'header.appearanceSession': 'Aparência e sessão',
  'header.settingsSecurity': 'Configurações e 2FA',
  'header.mobilePwaHint': 'Instale o app no celular para acesso rápido',
  'header.create': 'Criar',
  'header.createMenu': 'Criar no Office',
  'header.createTestHint': 'Gera um teste no Servidor',
  'header.createClientHint': 'Abre o formulário de novo cliente',
  'header.themeLight': 'Claro',
  'header.themeDark': 'Escuro',
  'header.myAccount': 'Minha conta',
  'header.editProfile': 'Editar perfil',
  'header.settings': 'Configurações',
  'header.logout': 'Sair',
  'session.tooltip': 'Tempo logado e auto-logout',
  'session.menuTitle': 'Sessão do Office',
  'session.menuHint': 'Veja há quanto tempo está logado e escolha quando encerrar automaticamente.',
  'session.loggedFor': 'Logado há',
  'session.remaining': 'Encerra em',
  'session.noLimit': 'Auto-logout desativado nesta sessão.',
  'session.currentLimit': 'Limite atual',
  'session.autoLogout': 'Deslogar automaticamente após',
  'session.resetClock': 'Reiniciar contagem',
  'session.badgeOff': 'livre',
  'session.opt.off': 'Desativado',
  'session.opt.30m': '30 minutos',
  'session.opt.1h': '1 hora',
  'session.opt.2h': '2 horas',
  'session.opt.3h': '3 horas',
  'session.opt.5h': '5 horas',
  'session.opt.8h': '8 horas',
  'session.opt.12h': '12 horas',
  'session.opt.24h': '24 horas',
  'session.savedOff': 'Auto-logout desativado',
  'session.savedOn': 'Auto-logout: {label}',
  'session.warnToast': 'Sessão encerra em {time}',
  'session.expiredToast': 'Sessão encerrada pelo temporizador',
  'header.health.checking': 'Verificando…',
  'header.health.checkingTitle': 'Verificando a conexão com o Servidor…',
  'header.health.none': 'Sem Servidor',
  'header.health.noneTitle': 'Nenhum servidor configurado',
  'header.health.offline': 'Servidor offline',
  'header.health.offlineTitle': 'Sem conexão estável com os servidores',
  'header.health.ok': 'Sistema saudável',
  'header.health.okTitleOne':
    'Sistema totalmente saudável — conexão estável com o servidor',
  'header.health.okTitleMany':
    'Sistema totalmente saudável — conexão estável com {n} servidores',
  'header.health.partial': '{ok}/{total} estáveis',
  'header.health.partialTitle': '{ok} de {total} servidores com conexão estável',
  'wp.header.network.ok': 'Rede saudável',
  'wp.header.network.okTitle': 'Sua conexão local está estável para streaming',
  'wp.header.network.fair': 'Rede instável',
  'wp.header.network.fairTitle': 'Conexão local oscilando — pode haver buffering',
  'wp.header.network.poor': 'Rede fraca',
  'wp.header.network.poorTitle': 'Conexão local fraca — verifique Wi‑Fi ou dados móveis',
  'wp.header.network.checking': 'A monitorizar…',
  'wp.header.network.checkingTitle': 'Medindo a qualidade da sua rede local…',
  'wp.header.network.speedEst': 'est.',
  'wp.header.network.speedTitle': 'Velocidade da sua rede local',
  'wp.header.activeUntil': '{status} · até {date}',
  'wp.header.trial': 'Teste',
  'wp.header.connectionsTitle': 'Conexões: {active}/{max}',
  'wp.sidebar.content': 'Conteúdo',
  'wp.sidebar.categories': 'Categorias',
  'wp.sidebar.live': 'Ao vivo',
  'wp.sidebar.movies': 'Filmes',
  'wp.sidebar.series': 'Séries',
  'wp.sidebar.search': 'Buscar título ou categoria…',
  'wp.sidebar.clearSearch': 'Limpar busca',
  'wp.sidebar.allCategories': 'Todas',
  'wp.sidebar.support': 'Suporte',
  'wp.sidebar.openWhatsapp': 'Abrir WhatsApp',
  'sidebar.search': 'Pesquisa rápida...',
  'sidebar.favorites': 'Favoritos',
  'sidebar.logout': 'Sair',
  'sidebar.creditsUnlimited': 'créditos ilimitados',
  'sidebar.creditsCount': '{n} créditos',
  'sidebar.postpaid': 'Modo crédito',
  'sidebar.role.admin': 'Administrador',
  'sidebar.role.reseller': 'Revendedor',
  'sidebar.role.attendant': 'Atendente',
  'sidebar.role.team': 'Equipe',
  'sidebar.mfaOn': '2FA Google Auth ativo',
  'sidebar.mfaOff': '2FA Google Auth desativado',
  'sidebar.poweredBy': 'Desenvolvido por',
  'sidebar.releaseHistory': 'Atualizações e melhorias',
  'sidebar.reportBug': 'Reportar bug',
  'sidebar.supportOpenWhatsapp': 'Abrir WhatsApp',
  'sidebar.supportChoiceDesc': 'Escolha o canal de sua preferência para entrar em contato com a equipe de suporte.',
  'sidebar.supportViaAtendimento': 'Atendimento do Office',
  'sidebar.supportViaAtendimentoHint': 'Central integrada — histórico, filas e respostas da equipe.',
  'sidebar.supportViaWhatsapp': 'WhatsApp',
  'sidebar.supportViaWhatsappHint': 'Abrir conversa diretamente no aplicativo.',
  'tools.title': 'Ferramentas',
  'tools.subtitle': 'Recursos avançados organizados por área de trabalho',
  'tools.search': 'Buscar ferramenta…',
  'tools.empty': 'Nenhuma ferramenta encontrada',
  'tools.group.relationship': 'Relacionamento e automação',
  'tools.group.finance': 'Financeiro',
  'tools.group.operation': 'Operação e manutenção',
  'tools.group.administration': 'Administração',
  'tools.group.other': 'Outras ferramentas',
  'nav.home': 'Início',
  'nav.crm': 'Atendimento',
  'nav.credits': 'Financeiro e créditos',
  'nav.management': 'Clientes e rede',
  'nav.iptv': 'Conteúdo',
  'nav.ops': 'Equipe e canais',
  'nav.config': 'Configurações',
  'nav.tools': 'Ferramentas',
  'nav.dashboard': 'Painel',
  'nav.chats': 'Atendimentos',
  'nav.meetings': 'Reuniões',
  'nav.finance': 'Financeiro',
  'nav.financeLogs': 'Registros financeiros',
  'nav.globalLogs': 'Registros globais',
  'nav.ranking': 'Ranking',
  'nav.templates': 'Notificações',
  'nav.buyCredits': 'Comprar créditos',
  'nav.addBalance': 'Adicionar saldo',
  'nav.clients': 'Clientes',
  'nav.tests': 'Testes',
  'nav.resellers': 'Revendas',
  'nav.myPortfolio': 'A minha carteira',
  'nav.categories': 'Planos',
  'nav.catalog': 'Conteúdos',
  'nav.whatsapp': 'WhatsApp',
  'nav.team': 'Equipe',
  'nav.teamMonitor': 'Monitor da equipe',
  'nav.settings': 'Ajustes',
  'nav.communitySupport': 'Comunidade & suporte',
  'nav.servers': 'Servidores',
  'nav.permissions': 'Permissões',
  'nav.leads': 'Contatos (CRM)',
  'nav.funnel': 'Funil de vendas',
  'nav.planPricing': 'Planos',
  'nav.credentials': 'Credenciais',
  'nav.resellerModes': 'Modos de revenda',
  'nav.myResellerBilling': 'Modos da minha rede',
  'nav.gateway': 'Integrações com bancos',
  'nav.creditPacks': 'Pacotes de crédito',
  'nav.checkoutNotif': 'Avisos de pagamento',
  'nav.salesMonitor': 'Monitor de vendas',
  'nav.creditLedger': 'Extrato de créditos',
  'nav.triggers': 'Gatilhos',
  'nav.chatbot': 'Chatbot',
  'nav.recuperacao': 'Sistema de Recuperação',
  'nav.inactiveClients': 'Clientes inativos',
  'nav.inactiveResellers': 'Revendas inativas',
  'nav.resellerMigration': 'Migração por M3U',
  'nav.materials': 'Materiais',
  'nav.materialsAdmin': 'Materiais para revenda',
  'hint.leads': 'Organize contatos, dados e etapas do atendimento.',
  'hint.funnel': 'Acompanhe seus contatos em cada etapa da venda.',
  'hint.buyCredits': 'Recargas do Modo crédito',
  'hint.addBalance': 'Compra de créditos',
  'hint.planPricing': 'Vitrine e edição de planos da rede',
  'hint.credentials': 'Defina como os usuários e as senhas são gerados.',
  'hint.resellerModes': 'Política do Modo crédito',
  'hint.myResellerBilling': 'Créditos para sub-revendas',
  'hint.gateway': 'Configure pagamentos, recebimentos e cobranças PIX.',
  'hint.creditPacks': 'Tabelas de venda',
  'hint.templates': 'Avisos WhatsApp de revenda e CRM',
  'hint.checkoutNotif': 'Avisos de pagamento',
  'hint.salesMonitor': 'IPTV vendas',
  'hint.creditLedger': 'Consulte entradas, saídas e saldo de créditos.',
  'hint.triggers': 'Crie fluxos de conversa, menus e respostas automáticas.',
  'hint.recuperacao': 'Organize campanhas de recuperação pelo WhatsApp.',
  'hint.inactiveClients': 'Revise clientes inativos e organize sua base.',
  'hint.inactiveResellers': 'Revise revendas sem atividade na sua rede.',
  'hint.resellerMigration': 'Importe clientes por URL M3U ou Xtream.',
  'hint.materialsAdmin': 'Disponibilize arquivos e orientações para a rede.',
  'page.office': 'Escritório',
  'page.leads': 'Contatos',
  'page.funnel': 'Funil de vendas',
  'page.plans': 'Planos',
  'page.contentPlans': 'Planos',
  'page.gateway': 'Integrações com bancos',
  'page.recuperacao': 'Sistema de Recuperação',
  'nav.actions': 'Ações',
  'nav.menu': 'Menu',
  'mobile.navAria': 'Navegação principal',
  'mobile.allPages': 'Todas as páginas',
  'mobile.allPagesHint': 'Pesquise e abra rotas disponíveis (respeita as suas permissões).',
  'mobile.search': 'Pesquisar…',
  'mobile.none': 'Nenhum resultado.',
  'quick.title': 'Ações rápidas',
  'quick.search': 'Pesquisar cliente/venda ou ir para…',
  'quick.empty': 'Nenhuma ação encontrada.',
  'quick.recent': 'Recentes',
  'quick.footerClose': 'fechar',
  'quick.footerNav': 'navegar',
  'quick.footerOpen': 'abrir',
  'quick.footerShortcut': 'atalho',
  'quick.test': 'Teste',
  'quick.testHint': 'Gerar teste usando pacotes do Servidor',
  'quick.plans': 'Planos e mensagens',
  'quick.plansHint': 'Checkout, preços e templates por pacote',
  'quick.clients': 'Clientes',
  'quick.clientsHint': 'Lista de clientes IPTV',
  'quick.addClient': 'Adicionar cliente',
  'quick.addClientHint': 'Abrir a tela de clientes para novo cadastro',
  'quick.renew': 'Renovar cliente',
  'quick.renewHint': 'Pesquisar e renovar por usuário/WhatsApp',
  'quick.resellers': 'Revendas',
  'quick.resellersHint': 'Gerenciar revendas e subcontas',
  'quick.credits': 'Adicionar créditos',
  'quick.creditsHint': 'Comprar créditos para ativação',
  'dqt.loading': 'A carregar…',
  'dqt.empty': 'Nenhum teste na lista.',
  'dqt.emptyHint': 'Em Planos (IPTV), ligue Teste no cartão. O Checkout pode ficar oculto.',
  'dqt.noResults': 'Nenhum resultado nesta pesquisa.',
  'dqt.search': 'Pesquisar',
  'dqt.catalog': 'Planos',
  'dqt.catalogAria': 'Abrir Planos',
  'dqt.planFallback': 'Plano de teste',
};

const en = {
  'lang.title': 'Language',
  'lang.choose': 'Choose language',
  'header.tools': 'Tools',
  'header.themeColor': 'Theme color',
  'header.toggleTheme': 'Toggle theme',
  'header.notifications': 'Notifications',
  'header.fullscreen': 'Fullscreen',
  'header.openMenu': 'Open menu',
  'header.mobilePrefs': 'Preferences',
  'header.mobilePrefsHint': 'Customize theme, color and language — syncs across all devices.',
  'header.quickAccess': 'Quick access',
  'header.personalization': 'Personalization',
  'header.mobileToolsHint': 'Operational shortcuts for your office',
  'header.mobileMore': 'Preferences and shortcuts',
  'header.shortcuts': 'Shortcuts',
  'header.navigation': 'Navigation',
  'header.workspace': 'Display and app',
  'header.lightMode': 'Light mode',
  'header.darkMode': 'Dark mode',
  'header.exitFullscreen': 'Exit fullscreen',
  'header.fullscreenUnavailable': 'Your browser did not allow fullscreen.',
  'header.appearanceSession': 'Appearance and session',
  'header.settingsSecurity': 'Settings and 2FA',
  'header.mobilePwaHint': 'Install the app on your phone for quick access',
  'header.create': 'Create',
  'header.createMenu': 'Create in Office',
  'header.createTestHint': 'Generate a quick trial on Servidor',
  'header.createClientHint': 'Open the new client form',
  'header.themeLight': 'Light',
  'header.themeDark': 'Dark',
  'header.myAccount': 'My account',
  'header.editProfile': 'Edit profile',
  'header.settings': 'Settings',
  'header.logout': 'Sign out',
  'session.tooltip': 'Time logged in and auto sign-out',
  'session.menuTitle': 'Office session',
  'session.menuHint': 'See how long you have been signed in and choose when to sign out automatically.',
  'session.loggedFor': 'Signed in for',
  'session.remaining': 'Ends in',
  'session.noLimit': 'Auto sign-out is off for this session.',
  'session.currentLimit': 'Current limit',
  'session.autoLogout': 'Sign out automatically after',
  'session.resetClock': 'Reset timer',
  'session.badgeOff': 'off',
  'session.opt.off': 'Off',
  'session.opt.30m': '30 minutes',
  'session.opt.1h': '1 hour',
  'session.opt.2h': '2 hours',
  'session.opt.3h': '3 hours',
  'session.opt.5h': '5 hours',
  'session.opt.8h': '8 hours',
  'session.opt.12h': '12 hours',
  'session.opt.24h': '24 hours',
  'session.savedOff': 'Auto sign-out disabled',
  'session.savedOn': 'Auto sign-out: {label}',
  'session.warnToast': 'Session ends in {time}',
  'session.expiredToast': 'Session ended by the timer',
  'header.health.checking': 'Checking…',
  'header.health.checkingTitle': 'Checking connection to Servidor…',
  'header.health.none': 'No Servidor',
  'header.health.noneTitle': 'No Servidor server configured',
  'header.health.offline': 'Servidor offline',
  'header.health.offlineTitle': 'No stable connection to Servidor servers',
  'header.health.ok': 'System healthy',
  'header.health.okTitleOne':
    'System fully healthy — stable connection to the Servidor server',
  'header.health.okTitleMany':
    'System fully healthy — stable connection to {n} Servidor servers',
  'header.health.partial': '{ok}/{total} stable',
  'header.health.partialTitle': '{ok} of {total} Servidor servers with a stable link',
  'wp.header.network.ok': 'Network healthy',
  'wp.header.network.okTitle': 'Your local connection is stable for streaming',
  'wp.header.network.fair': 'Unstable network',
  'wp.header.network.fairTitle': 'Local connection fluctuating — buffering may occur',
  'wp.header.network.poor': 'Weak network',
  'wp.header.network.poorTitle': 'Weak local connection — check Wi‑Fi or mobile data',
  'wp.header.network.checking': 'Monitoring…',
  'wp.header.network.checkingTitle': 'Measuring your local network quality…',
  'wp.header.network.speedEst': 'est.',
  'wp.header.network.speedTitle': 'Your local network speed',
  'wp.header.activeUntil': '{status} · until {date}',
  'wp.header.trial': 'Trial',
  'wp.header.connectionsTitle': 'Connections: {active}/{max}',
  'wp.sidebar.content': 'Content',
  'wp.sidebar.categories': 'Categories',
  'wp.sidebar.live': 'Live',
  'wp.sidebar.movies': 'Movies',
  'wp.sidebar.series': 'Series',
  'wp.sidebar.search': 'Search title or category…',
  'wp.sidebar.clearSearch': 'Clear search',
  'wp.sidebar.allCategories': 'All',
  'wp.sidebar.support': 'Support',
  'wp.sidebar.openWhatsapp': 'Open WhatsApp',
  'sidebar.search': 'Quick search...',
  'sidebar.favorites': 'Favorites',
  'sidebar.logout': 'Sign out',
  'sidebar.creditsUnlimited': 'unlimited credits',
  'sidebar.creditsCount': '{n} credits',
  'sidebar.postpaid': 'Credit mode',
  'sidebar.role.admin': 'Administrator',
  'sidebar.role.reseller': 'Reseller',
  'sidebar.role.attendant': 'Attendant',
  'sidebar.role.team': 'Team',
  'sidebar.mfaOn': '2FA Google Auth on',
  'sidebar.mfaOff': '2FA Google Auth off',
  'sidebar.poweredBy': 'Powered by',
  'sidebar.releaseHistory': 'Updates & improvements',
  'sidebar.reportBug': 'Report a bug',
  'sidebar.supportOpenWhatsapp': 'Open WhatsApp',
  'sidebar.supportChoiceDesc': 'Choose how you want to reach the support team.',
  'sidebar.supportViaAtendimento': 'Office inbox',
  'sidebar.supportViaAtendimentoHint': 'Integrated inbox — history, queues and team replies.',
  'sidebar.supportViaWhatsapp': 'WhatsApp',
  'sidebar.supportViaWhatsappHint': 'Open a chat directly in the app.',
  'tools.title': 'Tools',
  'tools.subtitle': 'Advanced resources organized by workspace',
  'tools.search': 'Search tools…',
  'tools.empty': 'No tools found',
  'tools.group.relationship': 'Customer relations and automation',
  'tools.group.finance': 'Finance',
  'tools.group.operation': 'Operations and maintenance',
  'tools.group.administration': 'Administration',
  'tools.group.other': 'Other tools',
  'nav.home': 'Home',
  'nav.crm': 'Customer service',
  'nav.credits': 'Finance and credits',
  'nav.management': 'Customers and network',
  'nav.iptv': 'Content',
  'nav.ops': 'Team and channels',
  'nav.config': 'Settings',
  'nav.tools': 'Tools',
  'nav.dashboard': 'Dashboard',
  'nav.chats': 'Inbox',
  'nav.meetings': 'Meetings',
  'nav.finance': 'Finance',
  'nav.financeLogs': 'Finance logs',
  'nav.globalLogs': 'Global logs',
  'nav.ranking': 'Ranking',
  'nav.templates': 'Notifications',
  'nav.buyCredits': 'Buy credits',
  'nav.addBalance': 'Add balance',
  'nav.clients': 'Clients',
  'nav.tests': 'Trials',
  'nav.resellers': 'Resellers',
  'nav.myPortfolio': 'My portfolio',
  'nav.categories': 'Plans',
  'nav.catalog': 'Content',
  'nav.whatsapp': 'WhatsApp',
  'nav.team': 'Team',
  'nav.teamMonitor': 'Team monitor',
  'nav.settings': 'Preferences',
  'nav.communitySupport': 'Community & support',
  'nav.servers': 'Servers',
  'nav.permissions': 'Permissions',
  'nav.leads': 'Leads (CRM)',
  'nav.funnel': 'Sales funnel',
  'nav.planPricing': 'Plans',
  'nav.credentials': 'Credentials',
  'nav.resellerModes': 'Reseller modes',
  'nav.myResellerBilling': 'My network modes',
  'nav.gateway': 'Bank integrations',
  'nav.creditPacks': 'Credit packs',
  'nav.checkoutNotif': 'Checkout alerts',
  'nav.salesMonitor': 'Sales monitor',
  'nav.creditLedger': 'Credit ledger',
  'nav.triggers': 'Triggers',
  'nav.chatbot': 'Chatbot',
  'nav.recuperacao': 'Recovery System',
  'nav.inactiveClients': 'Inactive clients',
  'nav.inactiveResellers': 'Inactive resellers',
  'nav.resellerMigration': 'M3U migration',
  'nav.materials': 'Materials',
  'nav.materialsAdmin': 'Reseller materials',
  'hint.leads': 'Contacts and stages',
  'hint.funnel': 'Lead kanban',
  'hint.buyCredits': 'Credit mode top-ups',
  'hint.addBalance': 'Credit purchase',
  'hint.planPricing': 'Network showcase and plan editing',
  'hint.credentials': 'Default user/password',
  'hint.resellerModes': 'Credit mode policy',
  'hint.myResellerBilling': 'Credits for sub-resellers',
  'hint.gateway': 'Mercado Pago',
  'hint.creditPacks': 'Sales tables',
  'hint.templates': 'Reseller and CRM WhatsApp notices',
  'hint.checkoutNotif': 'Payment notices',
  'hint.salesMonitor': 'IPTV sales',
  'hint.creditLedger': 'IPTV wallet movements',
  'hint.triggers': 'CRM automations',
  'hint.recuperacao': 'WhatsApp campaigns with AI',
  'hint.inactiveClients': 'Base cleanup',
  'hint.inactiveResellers': 'Tree cleanup',
  'hint.resellerMigration': 'Import clients from M3U or Xtream URLs',
  'hint.materialsAdmin': 'Library and uploads',
  'page.office': 'Office',
  'page.leads': 'Leads',
  'page.funnel': 'Funnel',
  'page.plans': 'Plans',
  'page.contentPlans': 'Plans',
  'page.gateway': 'Bank integrations',
  'page.recuperacao': 'Recovery System',
  'nav.actions': 'Actions',
  'nav.menu': 'Menu',
  'mobile.navAria': 'Main navigation',
  'mobile.allPages': 'All pages',
  'mobile.allPagesHint': 'Search and open available routes (follows your permissions).',
  'mobile.search': 'Search…',
  'mobile.none': 'No results.',
  'quick.title': 'Quick actions',
  'quick.search': 'Search a client/sale or jump to…',
  'quick.empty': 'No actions found.',
  'quick.recent': 'Recents',
  'quick.footerClose': 'close',
  'quick.footerNav': 'navigate',
  'quick.footerOpen': 'open',
  'quick.footerShortcut': 'shortcut',
  'quick.test': 'Quick Test',
  'quick.testHint': 'Generate a trial from Servidor packages',
  'quick.plans': 'Plans & messages',
  'quick.plansHint': 'Checkout, prices and templates per package',
  'quick.clients': 'Clients',
  'quick.clientsHint': 'IPTV client list',
  'quick.addClient': 'Add client',
  'quick.addClientHint': 'Open the clients screen for a new signup',
  'quick.renew': 'Renew client',
  'quick.renewHint': 'Search and renew by username/WhatsApp',
  'quick.resellers': 'Resellers',
  'quick.resellersHint': 'Manage resellers and sub-accounts',
  'quick.credits': 'Add credits',
  'quick.creditsHint': 'Buy credits for activations',
  'dqt.loading': 'Loading…',
  'dqt.empty': 'No trials in the list.',
  'dqt.emptyHint': 'In Plans (IPTV), turn on Quick Test on the card. Checkout can stay hidden.',
  'dqt.noResults': 'No results in this search.',
  'dqt.search': 'Search',
  'dqt.catalog': 'Plans',
  'dqt.catalogAria': 'Open Plans',
  'dqt.planFallback': 'Trial plan',
};

const es = {
  'lang.title': 'Idioma',
  'lang.choose': 'Elegir idioma',
  'header.tools': 'Herramientas',
  'header.themeColor': 'Color del tema',
  'header.toggleTheme': 'Cambiar tema',
  'header.notifications': 'Notificaciones',
  'header.fullscreen': 'Pantalla completa',
  'header.openMenu': 'Abrir menú',
  'header.mobilePrefs': 'Preferencias',
  'header.mobilePrefsHint': 'Personaliza tema, color e idioma — se sincroniza en todos los dispositivos.',
  'header.quickAccess': 'Acceso rápido',
  'header.personalization': 'Personalización',
  'header.mobileToolsHint': 'Atajos operativos del escritorio',
  'header.mobileMore': 'Preferencias y atajos',
  'header.shortcuts': 'Atajos',
  'header.navigation': 'Navegación',
  'header.workspace': 'Visualización y aplicación',
  'header.lightMode': 'Modo claro',
  'header.darkMode': 'Modo oscuro',
  'header.exitFullscreen': 'Salir de pantalla completa',
  'header.fullscreenUnavailable': 'Tu navegador no permitió abrir la pantalla completa.',
  'header.appearanceSession': 'Apariencia y sesión',
  'header.settingsSecurity': 'Configuración y 2FA',
  'header.mobilePwaHint': 'Instala la app en el móvil para acceso rápido',
  'header.create': 'Crear',
  'header.createMenu': 'Crear en el Office',
  'header.createTestHint': 'Genera una prueba rápida en Servidor',
  'header.createClientHint': 'Abre el formulario de nuevo cliente',
  'header.themeLight': 'Claro',
  'header.themeDark': 'Oscuro',
  'header.myAccount': 'Mi cuenta',
  'header.editProfile': 'Editar perfil',
  'header.settings': 'Configuración',
  'header.logout': 'Salir',
  'session.tooltip': 'Tiempo conectado y cierre automático',
  'session.menuTitle': 'Sesión del Office',
  'session.menuHint': 'Vea cuánto tiempo lleva conectado y elija cuándo cerrar sesión automáticamente.',
  'session.loggedFor': 'Conectado hace',
  'session.remaining': 'Termina en',
  'session.noLimit': 'Cierre automático desactivado en esta sesión.',
  'session.currentLimit': 'Límite actual',
  'session.autoLogout': 'Cerrar sesión automáticamente después de',
  'session.resetClock': 'Reiniciar contador',
  'session.badgeOff': 'libre',
  'session.opt.off': 'Desactivado',
  'session.opt.30m': '30 minutos',
  'session.opt.1h': '1 hora',
  'session.opt.2h': '2 horas',
  'session.opt.3h': '3 horas',
  'session.opt.5h': '5 horas',
  'session.opt.8h': '8 horas',
  'session.opt.12h': '12 horas',
  'session.opt.24h': '24 horas',
  'session.savedOff': 'Cierre automático desactivado',
  'session.savedOn': 'Cierre automático: {label}',
  'session.warnToast': 'La sesión termina en {time}',
  'session.expiredToast': 'Sesión cerrada por el temporizador',
  'header.health.checking': 'Verificando…',
  'header.health.checkingTitle': 'Comprobando la conexión con Servidor…',
  'header.health.none': 'Sin Servidor',
  'header.health.noneTitle': 'Ningún servidor configurado',
  'header.health.offline': 'Servidor offline',
  'header.health.offlineTitle': 'Sin conexión estable a los servidores',
  'header.health.ok': 'Sistema saludable',
  'header.health.okTitleOne':
    'Sistema totalmente saludable — conexión estable con el servidor',
  'header.health.okTitleMany':
    'Sistema totalmente saludable — conexión estable con {n} servidores',
  'header.health.partial': '{ok}/{total} estables',
  'header.health.partialTitle': '{ok} de {total} servidores con enlace estable',
  'wp.header.network.ok': 'Red saludable',
  'wp.header.network.okTitle': 'Su conexión local es estable para streaming',
  'wp.header.network.fair': 'Red inestable',
  'wp.header.network.fairTitle': 'Conexión local fluctuante — puede haber buffering',
  'wp.header.network.poor': 'Red débil',
  'wp.header.network.poorTitle': 'Conexión local débil — revise Wi‑Fi o datos móviles',
  'wp.header.network.checking': 'Monitoreando…',
  'wp.header.network.checkingTitle': 'Midiendo la calidad de su red local…',
  'wp.header.network.speedEst': 'est.',
  'wp.header.network.speedTitle': 'Velocidad de su red local',
  'wp.header.activeUntil': '{status} · hasta {date}',
  'wp.header.trial': 'Prueba',
  'wp.header.connectionsTitle': 'Conexiones: {active}/{max}',
  'wp.sidebar.content': 'Contenido',
  'wp.sidebar.categories': 'Categorías',
  'wp.sidebar.live': 'En vivo',
  'wp.sidebar.movies': 'Películas',
  'wp.sidebar.series': 'Series',
  'wp.sidebar.search': 'Buscar título o categoría…',
  'wp.sidebar.clearSearch': 'Limpiar búsqueda',
  'wp.sidebar.allCategories': 'Todas',
  'wp.sidebar.support': 'Soporte',
  'wp.sidebar.openWhatsapp': 'Abrir WhatsApp',
  'sidebar.search': 'Búsqueda rápida...',
  'sidebar.favorites': 'Favoritos',
  'sidebar.logout': 'Salir',
  'sidebar.creditsUnlimited': 'créditos ilimitados',
  'sidebar.creditsCount': '{n} créditos',
  'sidebar.postpaid': 'Modo crédito',
  'sidebar.role.admin': 'Administrador',
  'sidebar.role.reseller': 'Revendedor',
  'sidebar.role.attendant': 'Atendente',
  'sidebar.role.team': 'Equipo',
  'sidebar.mfaOn': '2FA Google Auth activo',
  'sidebar.mfaOff': '2FA Google Auth desactivado',
  'sidebar.poweredBy': 'Desarrollado por',
  'sidebar.releaseHistory': 'Actualizaciones y mejoras',
  'sidebar.reportBug': 'Reportar error',
  'sidebar.supportOpenWhatsapp': 'Abrir WhatsApp',
  'sidebar.supportChoiceDesc': 'Elija el canal preferido para entrar em contato com al equipo de soporte.',
  'sidebar.supportViaAtendimento': 'Atención del Office',
  'sidebar.supportViaAtendimentoHint': 'Central integrada — historial, colas y respuestas del equipo.',
  'sidebar.supportViaWhatsapp': 'WhatsApp',
  'sidebar.supportViaWhatsappHint': 'Abrir conversación diretamente en la aplicación.',
  'tools.title': 'Herramientas',
  'tools.subtitle': 'Recursos avanzados organizados por área de trabajo',
  'tools.search': 'Buscar herramienta…',
  'tools.empty': 'No se encontraron herramientas',
  'tools.group.relationship': 'Relación con clientes y automatización',
  'tools.group.finance': 'Finanzas',
  'tools.group.operation': 'Operación y mantenimiento',
  'tools.group.administration': 'Administración',
  'tools.group.other': 'Otras herramientas',
  'nav.home': 'Inicio',
  'nav.crm': 'Atención',
  'nav.credits': 'Finanzas y créditos',
  'nav.management': 'Clientes y red',
  'nav.iptv': 'Contenido',
  'nav.ops': 'Equipo y canales',
  'nav.config': 'Configuración',
  'nav.tools': 'Herramientas',
  'nav.dashboard': 'Panel',
  'nav.chats': 'Atenciones',
  'nav.meetings': 'Reuniones',
  'nav.finance': 'Financiero',
  'nav.financeLogs': 'Registros financieros',
  'nav.globalLogs': 'Registros globales',
  'nav.ranking': 'Ranking',
  'nav.templates': 'Notificaciones',
  'nav.buyCredits': 'Comprar créditos',
  'nav.addBalance': 'Añadir saldo',
  'nav.clients': 'Clientes',
  'nav.tests': 'Pruebas',
  'nav.resellers': 'Revendedores',
  'nav.myPortfolio': 'Mi cartera',
  'nav.categories': 'Planes',
  'nav.catalog': 'Contenidos',
  'nav.whatsapp': 'WhatsApp',
  'nav.team': 'Equipo',
  'nav.teamMonitor': 'Monitor del equipo',
  'nav.settings': 'Ajustes',
  'nav.communitySupport': 'Comunidad y soporte',
  'nav.servers': 'Servidores',
  'nav.permissions': 'Permisos',
  'nav.leads': 'Contactos (CRM)',
  'nav.funnel': 'Embudo de ventas',
  'nav.planPricing': 'Planes',
  'nav.credentials': 'Credenciales',
  'nav.resellerModes': 'Modos de reventa',
  'nav.myResellerBilling': 'Modos de mi red',
  'nav.gateway': 'Integraciones con bancos',
  'nav.creditPacks': 'Paquetes de crédito',
  'nav.checkoutNotif': 'Avisos de pago',
  'nav.salesMonitor': 'Monitor de ventas',
  'nav.creditLedger': 'Extracto de créditos',
  'nav.triggers': 'Disparadores',
  'nav.chatbot': 'Chatbot',
  'nav.recuperacao': 'Sistema de Recuperación',
  'nav.inactiveClients': 'Clientes inactivos',
  'nav.inactiveResellers': 'Revendedores inactivos',
  'nav.resellerMigration': 'Migración por M3U',
  'nav.materials': 'Materiales',
  'nav.materialsAdmin': 'Materiales para reventa',
  'hint.leads': 'Contactos y etapas',
  'hint.funnel': 'Tablero de contactos',
  'hint.buyCredits': 'Recargas del modo crédito',
  'hint.addBalance': 'Compra de créditos',
  'hint.planPricing': 'Vitrina y edición de planes de la red',
  'hint.credentials': 'Usuario y contraseña por defecto',
  'hint.resellerModes': 'Política del modo crédito',
  'hint.myResellerBilling': 'Créditos para sub-revendedores',
  'hint.gateway': 'Mercado Pago',
  'hint.creditPacks': 'Tablas de venta',
  'hint.templates': 'Avisos WhatsApp de reventa y CRM',
  'hint.checkoutNotif': 'Avisos de pago',
  'hint.salesMonitor': 'Ventas IPTV',
  'hint.creditLedger': 'Movimientos de cartera IPTV',
  'hint.triggers': 'Automatizaciones de atención',
  'hint.recuperacao': 'Campañas WhatsApp con IA',
  'hint.inactiveClients': 'Limpieza de base',
  'hint.inactiveResellers': 'Limpieza de árbol',
  'hint.resellerMigration': 'Importa clientes desde URLs M3U o Xtream',
  'hint.materialsAdmin': 'Biblioteca y envíos',
  'page.office': 'Oficina',
  'page.leads': 'Contactos',
  'page.funnel': 'Embudo de ventas',
  'page.recuperacao': 'Sistema de Recuperación',
  'page.plans': 'Planes',
  'page.contentPlans': 'Planes',
  'page.gateway': 'Integraciones con bancos',
  'nav.actions': 'Acciones',
  'nav.menu': 'Menú',
  'mobile.navAria': 'Navegación principal',
  'mobile.allPages': 'Todas las páginas',
  'mobile.allPagesHint': 'Busca y abre rutas disponibles (respeta tus permisos).',
  'mobile.search': 'Buscar…',
  'mobile.none': 'Ningún resultado.',
  'quick.title': 'Acciones rápidas',
  'quick.search': 'Buscar cliente/venta o ir a…',
  'quick.empty': 'Ninguna acción encontrada.',
  'quick.recent': 'Recientes',
  'quick.footerClose': 'cerrar',
  'quick.footerNav': 'navegar',
  'quick.footerOpen': 'abrir',
  'quick.footerShortcut': 'atajo',
  'quick.test': 'Prueba rápida',
  'quick.testHint': 'Generar prueba con paquetes Servidor',
  'quick.plans': 'Planes y mensajes',
  'quick.plansHint': 'Checkout, precios y plantillas por paquete',
  'quick.clients': 'Clientes',
  'quick.clientsHint': 'Lista de clientes IPTV',
  'quick.addClient': 'Añadir cliente',
  'quick.addClientHint': 'Abrir la pantalla de clientes para un alta nueva',
  'quick.renew': 'Renovar cliente',
  'quick.renewHint': 'Buscar y renovar por usuario/WhatsApp',
  'quick.resellers': 'Reventas',
  'quick.resellersHint': 'Gestionar reventas y subcuentas',
  'quick.credits': 'Añadir créditos',
  'quick.creditsHint': 'Comprar créditos para activación',
  'dqt.loading': 'Cargando…',
  'dqt.empty': 'Ninguna prueba en la lista.',
  'dqt.emptyHint': 'En Planes (IPTV), activa Prueba rápida en la tarjeta. El checkout puede quedar oculto.',
  'dqt.noResults': 'Ningún resultado en esta búsqueda.',
  'dqt.search': 'Buscar',
  'dqt.catalog': 'Planes',
  'dqt.catalogAria': 'Abrir Planes',
  'dqt.planFallback': 'Plan de prueba',
};

export const MESSAGES = {
  'pt-BR': {
    ...ptBR,
    ...PAGE_MESSAGES['pt-BR'],
    ...MODAL_MESSAGES['pt-BR'],
    ...ROLE_UI_MESSAGES['pt-BR'],
    ...OPS_UI_MESSAGES['pt-BR'],
  },
  en: {
    ...en,
    ...PAGE_MESSAGES.en,
    ...MODAL_MESSAGES.en,
    ...ROLE_UI_MESSAGES.en,
    ...OPS_UI_MESSAGES.en,
  },
  es: {
    ...es,
    ...PAGE_MESSAGES.es,
    ...MODAL_MESSAGES.es,
    ...ROLE_UI_MESSAGES.es,
    ...OPS_UI_MESSAGES.es,
  },
};

/** path → chave i18n para títulos / itens de menu */
export const PATH_LABEL_KEYS = {
  '/dashboard': 'nav.dashboard',
  '/chats': 'nav.chats',
  '/reunioes': 'nav.meetings',
  '/sales': 'nav.finance',
  '/logs-financeiros': 'nav.financeLogs',
  '/logs-globais': 'nav.globalLogs',
  '/ranking': 'nav.ranking',
  '/notification-templates': 'nav.templates',
  '/buy-credits': 'nav.buyCredits',
  '/postpaid-wallet': 'nav.addBalance',
  '/gestor-xui/clients': 'nav.clients',
  '/gestor-xui/live-clients': 'nav.liveClients',
  '/gestor-xui/tests': 'nav.tests',
  '/gestor-xui/resellers': 'nav.resellers',
  '/gestor-xui/my-portfolio': 'nav.myPortfolio',
  '/gestor-xui/categories': 'nav.categories',
  '/gestor-xui/catalog': 'nav.catalog',
  '/connections': 'nav.whatsapp',
  '/team': 'nav.team',
  '/team/monitor': 'nav.teamMonitor',
  '/settings': 'nav.settings',
  '/community-support': 'nav.communitySupport',
  '/gestor-xui/servers': 'nav.servers',
  '/permissions': 'nav.permissions',
  '/contacts': 'nav.leads',
  '/funnel': 'nav.funnel',
  '/gestor-xui/plan-pricing': 'nav.categories',
  '/gestor-xui/credential-generation': 'nav.credentials',
  '/gestor-xui/reseller-billing': 'nav.resellerModes',
  '/gestor-xui/my-reseller-billing': 'nav.myResellerBilling',
  '/gestor-xui/gateway': 'nav.gateway',
  '/gestor-xui/credit-packs': 'nav.creditPacks',
  '/gestor-xui/checkout-notifications': 'nav.checkoutNotif',
  '/gestor-xui/sales': 'nav.salesMonitor',
  '/gestor-xui/credit-logs': 'nav.creditLedger',
  '/triggers': 'nav.triggers',
  '/triggers/chatbot': 'nav.chatbot',
  '/recuperacao': 'nav.recuperacao',
  '/mass-dispatch': 'nav.recuperacao',
  '/gestor-xui/inactive-clients': 'nav.inactiveClients',
  '/gestor-xui/inactive-resellers': 'nav.inactiveResellers',
  '/gestor-xui/reseller-migration': 'nav.resellerMigration',
  '/materiais': 'nav.materials',
  '/admin/materiais': 'nav.materialsAdmin',
};

export const PATH_HINT_KEYS = {
  '/contacts': 'hint.leads',
  '/funnel': 'hint.funnel',
  '/buy-credits': 'hint.buyCredits',
  '/postpaid-wallet': 'hint.addBalance',
  '/gestor-xui/categories': 'hint.planPricing',
  '/gestor-xui/plan-pricing': 'hint.planPricing',
  '/gestor-xui/credential-generation': 'hint.credentials',
  '/gestor-xui/reseller-billing': 'hint.resellerModes',
  '/gestor-xui/my-reseller-billing': 'hint.myResellerBilling',
  '/gestor-xui/gateway': 'hint.gateway',
  '/gestor-xui/credit-packs': 'hint.creditPacks',
  '/notification-templates': 'hint.templates',
  '/gestor-xui/checkout-notifications': 'hint.checkoutNotif',
  '/gestor-xui/sales': 'hint.salesMonitor',
  '/gestor-xui/credit-logs': 'hint.creditLedger',
  '/triggers': 'hint.triggers',
  '/recuperacao': 'hint.recuperacao',
  '/mass-dispatch': 'hint.recuperacao',
  '/gestor-xui/inactive-clients': 'hint.inactiveClients',
  '/gestor-xui/inactive-resellers': 'hint.inactiveResellers',
  '/gestor-xui/reseller-migration': 'hint.resellerMigration',
  '/admin/materiais': 'hint.materialsAdmin',
};

export const MODULE_LABEL_KEYS = {
  home: 'nav.home',
  crm: 'nav.crm',
  creditos: 'nav.credits',
  gestao: 'nav.management',
  iptv: 'nav.iptv',
  admin: 'nav.ops',
  config: 'nav.config',
  ferramentas: 'nav.tools',
};

/** Títulos de página que diferem ligeiramente do nav */
export const PAGE_TITLE_KEYS = {
  ...PATH_LABEL_KEYS,
  '/contacts': 'page.leads',
  '/funnel': 'page.funnel',
  '/gestor-xui/categories': 'page.plans',
  '/gestor-xui/catalog': 'nav.catalog',
  '/gestor-xui/plan-pricing': 'page.plans',
  '/gestor-xui/gateway': 'page.gateway',
  '/recuperacao': 'page.recuperacao',
  '/mass-dispatch': 'page.recuperacao',
};

/** Subtítulos do PageShell por rota (localizam com o seletor de idioma) */
export const PAGE_SUBTITLE_KEYS = {
  '/dashboard': 'sub.dashboard',
  '/chats': 'sub.chats',
  '/reunioes': 'meetings.subtitle',
  '/sales': 'sub.finance',
  '/logs-financeiros': 'sub.financeLogs',
  '/logs-globais': 'sub.globalLogs',
  '/ranking': 'sub.ranking',
  '/notification-templates': 'sub.templates',
  '/buy-credits': 'sub.buyCredits',
  '/postpaid-wallet': 'sub.addBalance',
  '/gestor-xui/clients': 'sub.clients',
  '/gestor-xui/live-clients': 'sub.clients',
  '/gestor-xui/tests': 'sub.tests',
  '/gestor-xui/resellers': 'sub.resellers',
  '/gestor-xui/my-portfolio': 'sub.myPortfolio',
  '/gestor-xui/categories': 'sub.categories',
  '/gestor-xui/catalog': 'sub.catalog',
  '/connections': 'sub.whatsapp',
  '/team': 'sub.team',
  '/team/monitor': 'sub.teamMonitor',
  '/settings': 'sub.settings',
  '/community-support': 'sub.communitySupport',
  '/gestor-xui/servers': 'sub.servers',
  '/permissions': 'sub.permissions',
  '/contacts': 'sub.leads',
  '/funnel': 'sub.funnel',
  '/gestor-xui/plan-pricing': 'sub.categories',
  '/gestor-xui/credential-generation': 'sub.credentials',
  '/gestor-xui/reseller-billing': 'sub.resellerModes',
  '/gestor-xui/my-reseller-billing': 'sub.myResellerBilling',
  '/gestor-xui/gateway': 'sub.gateway',
  '/gestor-xui/credit-packs': 'sub.creditPacks',
  '/gestor-xui/checkout-notifications': 'sub.checkoutNotif',
  '/gestor-xui/sales': 'sub.salesMonitor',
  '/gestor-xui/credit-logs': 'sub.creditLedger',
  '/triggers': 'sub.triggers',
  '/recuperacao': 'sub.recuperacao',
  '/mass-dispatch': 'sub.recuperacao',
  '/gestor-xui/inactive-clients': 'sub.inactiveClients',
  '/gestor-xui/inactive-resellers': 'sub.inactiveResellers',
  '/gestor-xui/reseller-migration': 'sub.resellerMigration',
};

/** Eyebrow do PageShell (hero) por rota */
export const PAGE_EYEBROW_KEYS = {
  '/dashboard': 'eyebrow.home',
  '/chats': 'eyebrow.crm',
  '/sales': 'eyebrow.crm',
  '/logs-financeiros': 'eyebrow.crm',
  '/logs-globais': 'eyebrow.crm',
  '/ranking': 'eyebrow.crm',
  '/notification-templates': 'eyebrow.crm',
  '/buy-credits': 'eyebrow.credits',
  '/postpaid-wallet': 'eyebrow.credits',
  '/gestor-xui/clients': 'eyebrow.management',
  '/gestor-xui/live-clients': 'eyebrow.management',
  '/gestor-xui/tests': 'eyebrow.management',
  '/gestor-xui/resellers': 'eyebrow.management',
  '/gestor-xui/my-portfolio': 'eyebrow.management',
  '/gestor-xui/categories': 'eyebrow.iptv',
  '/gestor-xui/catalog': 'eyebrow.iptv',
  '/connections': 'eyebrow.ops',
  '/team': 'eyebrow.ops',
  '/team/monitor': 'eyebrow.ops',
  '/settings': 'eyebrow.config',
  '/community-support': 'eyebrow.config',
  '/gestor-xui/servers': 'eyebrow.config',
  '/permissions': 'eyebrow.config',
  '/contacts': 'eyebrow.crm',
  '/funnel': 'eyebrow.tools',
  '/gestor-xui/plan-pricing': 'eyebrow.iptv',
  '/gestor-xui/credential-generation': 'eyebrow.tools',
  '/gestor-xui/reseller-billing': 'eyebrow.tools',
  '/gestor-xui/my-reseller-billing': 'eyebrow.management',
  '/gestor-xui/gateway': 'eyebrow.tools',
  '/gestor-xui/credit-packs': 'eyebrow.tools',
  '/gestor-xui/checkout-notifications': 'eyebrow.tools',
  '/gestor-xui/sales': 'eyebrow.tools',
  '/gestor-xui/credit-logs': 'eyebrow.tools',
  '/triggers': 'eyebrow.tools',
  '/recuperacao': 'eyebrow.tools',
  '/mass-dispatch': 'eyebrow.tools',
  '/gestor-xui/inactive-clients': 'eyebrow.tools',
  '/gestor-xui/inactive-resellers': 'eyebrow.tools',
  '/gestor-xui/reseller-migration': 'eyebrow.tools',
};
